// Dependencies
import { createBrowserRouter } from "react-router-dom";

// Project imports
import routes from "./routes";

const router = createBrowserRouter(routes);

export default router;
